import React from "react";

const TawkelPrint = ({
  NameMowakel,
  SefaMowakel,
  TawkelStatus,
  NameWakel,
  Gharad,
  NumberTawkel,
  TypeTwakel,
  Gehaa,
  DateTawkel,
}) => {
  return (
    <>
      <div id="printt">
        <h3 className="text-center m-3">بيانات التوكيل</h3>
        <p>
          <span>اسم الموكل: </span>
          {NameMowakel?.Name}
        </p>
        <p>
          <span>صفة الموكل: </span>
          {SefaMowakel}
        </p>
        <p>
          <span>اسم الوكيل: </span>
          {NameWakel}
        </p>
        <p>
          <span>رقم التوكيل: </span>
          {NumberTawkel}
        </p>
        <p>
          <span>نوع التوكيل: </span>
          {TypeTwakel?.Name}
        </p>
        <p>
          <span>جهة التوثيق: </span>
          {Gehaa?.Name}
        </p>
        <p>
          <span>تاريخ التوكيل: </span>
          {new Date(DateTawkel).toLocaleDateString("en-GB")}
        </p>
        <p>
          <span>الغرض من التوكيل: </span>
          {Gharad}
        </p>
        <p>
          <span>حالة التوكيل: </span>
          {TawkelStatus?.Status}
        </p>
      </div>
    </>
  );
};

export default TawkelPrint;
